module.exports = __webpack_public_path__ + "src/client/assets/partner-logos/bench-white.png";